import React from 'react';
import Web3 from 'web3';
import axios from 'axios';
import "./cykAccount.css";


class CykAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accountState: 0, //0 Checking for Account, 1 No account exists, 2 account exists, 3 wallet delisted, 4 account created, 5 error with network
            tpsId: props.thetaDropAccount
        }

    }


    async componentDidMount() {
        this.checkIfAccountExists();
    }

    checkIfAccountExists = async () => {

        //0 loading = done
        //1 no account exists in progress
        //2 account exists 
        //5 network error
        const postLink = "https://9jutyosq80.execute-api.us-east-1.amazonaws.com/production/checkifaccountexists";
        const postData = {
            "api": "U5tnRp4m",
            "thetaDropId": this.state.tpsId
        }

        try {
            const result = await axios.post(postLink, postData);
            if (result.data.statusCode === 200) {
                this.setState({ accountState: 1 });
            } else if (result.data.statusCode === 201) {
                this.setState({ accountState: 2 });
                const info = JSON.parse(result.data.body);
                this.setState({metaMaskWallet : info.metaMaskWallet1})
            } else {
                this.setState({ accountState: 5 })
            }
        } catch (e) {
            console.log(e)
            this.setState({ accountState: 5 });
        }


    }


    signMessage = async (e) => {
        //add network check
        //mobile check
        alert('Please approve the signature in MetaMask. This will NOT cost you any TFuel. Please also do NOT close out of the browser until it is finished.');

        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const networkIdHex = await window.ethereum.networkVersion;
            const hexToDecimal = hex => parseInt(hex, 16);
            const networkId = hexToDecimal(networkIdHex);
            
            if(networkId !== 361){
                alert("Not connected to The Theta Network");
                return;
            }

            const info = {
                metaMaskWallet: accounts[0],
                thetadropId: this.state.tpsId
            }


            try {

                window.web3 = new Web3(window.ethereum);
                const signedMessage = await window.web3.eth.personal.sign(
                    JSON.stringify(info),
                    accounts[0]
                );

                const postLink = "https://9jutyosq80.execute-api.us-east-1.amazonaws.com/production/addnewaccount";
                const postData = {
                    "api": "FNyH3xys",
                    "signature": signedMessage,
                    "message": {
                        "metaMaskWallet": accounts[0],
                        "thetadropId": this.state.tpsId
                    }
                }


                try {
                    const result = await axios.post(postLink, postData);
                    if (result.data.statusCode === 200) {
                        alert("Account Created!");
                        this.setState({ accountState: 4 });
                        this.setState({metaMaskWallet: accounts[0]})
                    } else{
                        this.setState({ accountState: 5 });
                    }
                } catch (e) {
                    console.log(e)
                    this.setState({ accountState: 5 });
                }

            } catch (e) {
                alert(JSON.stringify(e));
            }
        } catch (e) {
            alert("Net work error..check MetaMask?");
        }

    }


    render() {
        return (
            <div className="cykAccount-main">
                <div className="cykAccount-main-overlay">

                    {
                        (this.state.accountState === 2 || this.state.accountState === 3 || this.state.accountState === 4) &&
                        <div>
                            <h2 className='cykAccount-title'>You're Suited Up for SuperEarth</h2>
                            <div className='cykAccount-sub-title'>
                                <h3>Ready for Blast Off!</h3>
                            </div>
                        </div>

                    }

                    {
                        (this.state.accountState !== 2 && this.state.accountState !== 3 && this.state.accountState !== 4) &&
                        <div>
                            <h2 className='cykAccount-title'>Make Your Cyko Account</h2>
                            <div className='cykAccount-sub-title'>
                                <h3>Connect Your Metamask Account to your ThetaDrop Account to Receive Drops, Prices Speical NFTs and more!</h3>
                            </div>
                        </div>

                    }
                    {
                        (this.state.accountState !== 0 && this.state.accountState !== 5) &&
                        <div className='createAccount-sub-container'>
                            <div className='createAccount-top-div'>
                                <div className='create-account-left'>
                                    <img src='./img/Theta Blue.png' alt='ThetaDrop Logo'></img>
                                </div>
                                <div className='create-account-right'>
                                    <img src='./img/mm.png' alt='Metamask Logo'></img>
                                </div>
                            </div>
                            <div className='createAccount-bottom-div'>
                                <div className='create-account-left'>
                                    <button>Connected!</button>
                                </div>
                                <div className='create-account-right'>
                                    {
                                        (this.state.accountState !== 2 && this.state.accountState !== 3 && this.state.accountState !== 4) &&
                                        <button onClick={(e) => this.signMessage(e)}>Verify Now</button>
                                    }
                                    {
                                        (this.state.accountState === 2 || this.state.accountState === 3 || this.state.accountState === 4) &&
                                        <button onClick={(e) => this.signMessage(e)}>Change Metamask Account</button>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {
                        this.state.accountState === 5 &&
                        <div className='createAccount-sub-container'>
                            <h2>Network Error, Please Try Again Later</h2>
                        </div>
                    }
                    {
                        (this.state.accountState === 2 || this.state.accountState === 3 || this.state.accountState === 4) &&
                        <div className='createAccount-bottom-text'>
                            <p>Theta Wallet: {this.state.metaMaskWallet}</p>
                        </div>

                    }
                </div>
            </div>
        );
    }
}

export default CykAccount;
